<!--
  新建 退货退款特殊字段
  prop:
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="redundant">
    <!-- 关联客户 -->
    <template v-if="item.attr === 'customerName'">
      <associated-field
        ref="associatedField"
        module="customerApi"
        :item="item"
        :form="form"
        @addNew="addNew"
        @emitObj="customerChange">
      </associated-field>
    </template>
    <!-- 关联合同 -->
    <template v-if="item.attr === 'contractId'">
      <associated-field
        v-if="form.customerName&&form.customerName.id"
        ref="associatedField"
        module="contractApi"
        :item="item"
        :form="form"
        :customerId="form.customerName.id"
        @addNew="addNew"
        @emitObj="contractChange">
      </associated-field>
      <span v-else>无</span>
    </template>
    <!-- 退货产品 -->
    <template v-if="item.attr === 'products'">
      <div class="products">
        <div class="v-area">
          <template v-if="form[item.attr] && form[item.attr].length">{{form[item.attr] | productLen}}</template>
          <template v-else>暂无关联产品</template>
        </div>
        <span class="add-btn" @click="emitParent(item.nonEditable)">选择</span>
      </div>
      <v-product
      ref="products"
      v-if="showProduct"
      :contractId="form.contractId"
      :select="form.products"
      :decimalPrecisionMap="item.decimalPrecisionMap"
      @close="showProduct = false"
      @emitProductsData="updateProducts">
      </v-product>
    </template>

  </div>
</template>

<script>
import * as utils from 'src/utils'
import remoteSelect from '../remote-select'
import associatedField from '../associated-field'
import vProduct from '../product-new'

export default {
  props: ['item', 'form'],
  data () {
    return {
      showProduct: false
    }
  },
  methods: {

    // 关联客户变更时，清空已选合同
    customerChange (obj) {
      this.form.contractId = ''
      this.form.products = ''
    },

    // 关联合同变更时，清空已选产品
    contractChange (obj) {
      this.form.products = ''

      // 写入合同金额
      if (obj) {
        this.form.returnAmount = obj.amount
      }
    },

    emitParent (nonEditable) {
      this.showProduct = true
    },

    // 更新已选产品
    updateProducts (arr, totalMoney) {
      this.$set(this.form, 'products', arr)

      //  更新表单的总的退货金额
      this.$emit('refundProTotalMoney', totalMoney)
    },

    addNew (arr) {
      this.$emit('addNew', arr)
    },
    refresh () {
      this.$refs.associatedField.refresh()
    }
  },
  filters: {
    productLen (arr) {
      let num = 0
      arr.forEach((item) => {
        num = utils.plus(num, item.num)
      })
      return `${arr.length}种产品${num}件`
    }
  },
  components: {
    remoteSelect,
    associatedField,
    vProduct
  }
}
</script>
<style lang="less" scoped>
  @import '../../../assets/less/fieldtype-products.less';
</style>



// WEBPACK FOOTER //
// index.vue?f14464fa